import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/reports",
  validateSearch: (search: Record<string, unknown>): { date?: string; driver?: string } => ({
    ...(typeof search.date === "string" ? { date: search.date } : {}),
    ...(typeof search.driver === "string" ? { driver: search.driver } : {}),
  }),
  beforeLoad: ({ context }) => {
    if (context.authLoading) return;
    if (!context.session) throw redirect({ to: "/auth/login" });
  },
  component: lazyRouteComponent(() => import("./reports"), "ReportApprovalPage"),
});
